import { niceScale } from "./chartScale";


// BarDatum is one labelled bar. The label is whatever the series is
// bucketed by — a month ("2026-07") on the progress page, the Monday of a
// week ("2026-09-07") for dashboard capability velocity.
export interface BarDatum {
  label: string;
  count: number;
}

// LabelledBarChart is a simple hand-rolled proportional bar chart (no
// charting library — consistent with DashboardStats.tsx's existing
// .plane-bar approach), shared by ADR velocity and PR merges by month on
// the progress page and by capability velocity by week on the dashboard. Bar width is relative to the largest count in the series.
export function LabelledBarChart({ data, ariaLabel = "Counts by period" }: { data: BarDatum[]; ariaLabel?: string }) {
  const { max, ticks } = niceScale(Math.max(0, ...data.map((d) => d.count)));
  return (
    <div className="month-bar-chart" role="img" aria-label={ariaLabel}>
      <div className="month-bar-gridlines" aria-hidden="true">
        {ticks.map((t) => (
          <div className="chart-gridline" key={t} style={{ left: `${(t / max) * 100}%` }}>
            <span className="chart-gridline-label">{t}</span>
          </div>
        ))}
      </div>
      {data.map((d) => (
        <div className="month-bar-row" key={d.label}>
          <span className="month-bar-label mono">{d.label}</span>
          <div className="month-bar-track">
            <span className="month-bar-fill" style={{ width: `${(d.count / max) * 100}%` }} />
          </div>
          <span className="month-bar-count">{d.count}</span>
        </div>
      ))}
    </div>
  );
}
